import { render, staticRenderFns } from "./centerLeft6.vue?vue&type=template&id=1225191c&scoped=true&"
import script from "./centerLeft6.vue?vue&type=script&lang=js&"
export * from "./centerLeft6.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft6.vue?vue&type=style&index=0&id=1225191c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1225191c",
  null
  
)

export default component.exports